import { keepPreviousData, useQuery } from "@tanstack/react-query";
import useIdentity from "@/features/ui/hooks/use-identity";
import { settlementManagementApi } from "@/features/my-order/features/settlement-management/api";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import {
  GetCreditInvoiceListRequest,
  GetCreditInvoiceListResponse,
} from "@/features/my-order/features/settlement-management/types";
import { toCamelKeyObject } from "@/utils/case";

interface UseGetCreditInvoiceListOptions {
  enabled?: boolean;
}

const useGetCreditInvoiceList = (
  params?: GetCreditInvoiceListRequest,
  options?: UseGetCreditInvoiceListOptions
) => {
  const identity = useIdentity();
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"] ??
    "buyers";
  const enabled = Boolean(companyId) && (options?.enabled ?? true);

  const { data, isPending, isFetching } = useQuery({
    queryKey: [
      "settlement",
      "credit-invoice-list",
      companyId,
      companyType,
      params,
    ],
    queryFn: () =>
      settlementManagementApi.getCreditInvoiceList(
        companyType,
        companyId as number,
        params
      ),
    enabled,
    select: (data) => toCamelKeyObject(data) as GetCreditInvoiceListResponse,
    placeholderData: keepPreviousData,
  });

  return { data, isPending, isFetching };
};

export default useGetCreditInvoiceList;
